import React, { useState } from "react";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Text from "../text/Text";
import Invalid from "./img/invalid.svg";
import dayjs from "dayjs";

export default function CustomTimePicker(props) {
  const {
    label,
    value,
    onChange,
    name,
    error,
    errorMessage,
    setError,
    disable,
    width = "100%",
    placeholder,
    disablePast,
    selectedDay,
  } = props;

  const [open, setOpen] = useState(false);

  const isCurrentDay = selectedDay
    ? dayjs(selectedDay).isSame(dayjs(), "day")
    : false;

  const handleTimeChange = (newTime) => {
    if (newTime && dayjs(newTime).isValid()) {
      const formattedTime = dayjs(newTime).format("HH:mm");
      onChange?.(formattedTime, name);
    } else {
      onChange?.(null, name);
    }
  };

  const openTimePicker = () => {
    if (!disable) {
      setOpen(true);
    }
  };

  return (
    <div
      className="text-input-container"
      style={{ width }}
      onClick={openTimePicker}
    >
      {label && (
        <Text
          size="0.875rem"
          color="#344054"
          weight="500"
          align="left"
          text={label}
        />
      )}

      <div className="text-input">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            disablePast={isCurrentDay}
            value={value ? dayjs(value, "HH:mm") : null}
            onChange={handleTimeChange}
            disabled={disable}
            onAccept={() => setOpen(false)}
            onClose={() => setOpen(false)}
            slotProps={{
              textField: {
                placeholder: placeholder,
                error: error,
                helperText: error ? errorMessage : "",
                fullWidth: true,
                variant: "outlined",
                sx: {
                  width,
                  "& .MuiOutlinedInput-root": {
                    display: "flex",
                    alignItems: "center",
                    padding: "0.485rem 0.875rem",
                    gap: "0.3rem",
                    fontWeight: 400,
                    fontSize: "0.875rem",
                    lineHeight: "1.4rem",
                    borderRadius: "0.5rem",
                    boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                    fontFamily: "Inter",
                    cursor: disable ? "not-allowed" : "pointer",
                    color: disable ? "#a0a0a0" : "#101828",
                    cursor: disable ? "not-allowed" : "pointer",
                    backgroundColor: disable ? "#fafafa" : "white",
                    "& fieldset": {
                      border: "0.063rem solid #D0D5DD !important",
                      transition: "all 0.2s ease-out",
                    },
                    "&:hover fieldset": {
                      borderColor: "#D0D5DD",
                    },
                    "&.Mui-focused fieldset": {
                      border: "0.063rem solid #D0D5DD",
                      boxShadow: "0 0 0.4rem rgba(74, 144, 226, 0.7)",
                    },
                    "&.Mui-error.Mui-focused fieldset": {
                      border: "0.063rem solid #FDA29C !important",
                      boxShadow: "none !important",
                    },
                    "&.Mui-error fieldset": {
                      border: "0.063rem solid #FDA29C !important",
                    },
                  },
                  "& .MuiInputBase-input": {
                    padding: 0,
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
}
